import { render, staticRenderFns } from "./DefaultNewCard.vue?vue&type=template&id=df28ad36&"
import script from "./DefaultNewCard.vue?vue&type=script&lang=js&"
export * from "./DefaultNewCard.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNewCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports